import type { ReactNode } from 'react';

import { PageDisclaimer } from '#/components/ui/PageDisclaimer';

interface ContentLayoutProps {
  children: ReactNode;
}

/**
 * Applies the three-column content grid. Children set their own col-* classes.
 *
 * Drawer open/collapsed state is handled entirely in CSS via the
 * [data-drawer-open] attribute set by DefinitionDrawerProvider
 */
export function ContentLayout({ children }: ContentLayoutProps) {
  return (
    <main
      id="content"
      className="grid-cols-content-mobile lg:grid-cols-content grid scroll-mt-(--scroll-offset) pb-28 lg:pt-28 lg:pb-64"
    >
      {children}

      <PageDisclaimer className="col-content" />
    </main>
  );
}
